export default __webpack_public_path__ + "static/media/Reflections.f871b009.pdf";